/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchEvaluationPathParams = NonNullable<operations['patchEvaluation']['parameters']['path']>;

export type PatchEvaluationRequestBody = OperationRequestBodyContent<operations['patchEvaluation']>;

export interface Input extends PatchEvaluationPathParams {
  apiVersion?: string;
  body: PatchEvaluationRequestBody;
}

export async function patchEvaluation(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projKey}/evaluations/{evaluationId}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
